import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UgovoriPopisService } from './ugovori-popis.service';
import { AppConfig } from '../../../config';
import { Ugovor } from './ugovor';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';

declare var moment: any;
import * as alertify from 'alertify.js';

@Component({
  selector: 'app-ugovori-popis',
  templateUrl: './ugovori-popis.component.html',
  styleUrls: ['./ugovori-popis.component.css'],
  providers: [UgovoriPopisService]
})
export class UgovoriPopisComponent implements OnInit {

  // @ViewChild('fileInput', {static: false}) fileInput;
  filee:any;

  sviUgovori: Ugovor[] = [];
  ugovorOptions: DataTables.Settings = {};
  ugovorTrigger: Subject<Ugovor> = new Subject();

  ugovorForma: FormGroup;
  ugovorEditForma: FormGroup;

  dokumentId: string;
  accessToken: any = localStorage.getItem('tokenSql');
  URL: any = AppConfig.IPfile;

  constructor(
    private _fb: FormBuilder,
    private _ugovoriPopisService: UgovoriPopisService
  ) { }

  ngOnInit() {
    this.dohvati();
    //Tablica početak
    this.ugovorOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.ugovorForma = this._fb.group({
      naziv: [''],
      file: ['']
    });
    this.ugovorEditForma = this._fb.group({
      naziv: ['']
    });
  }

  pripremiPodatke(ugovor){
    //console.log(ugovor);
    this.dokumentId = ugovor['id'];
    this.ugovorEditForma = this._fb.group({
      naziv: ugovor['naziv']
    });
  }

  uredi(ugovor){
    //console.log(ugovor);
    let podaciZaSlanje = {
      'iduploaddokument': this.dokumentId,
      'naziv': ugovor['naziv'],
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._ugovoriPopisService.urediDokument(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremi(ugovorForma){
    //console.log(ugovorForma);
    if(ugovorForma['naziv'] && ugovorForma['file']){
      let formData:FormData = new FormData();
      formData.append('naziv', ugovorForma.naziv);
      formData.append('datoteka', this.filee[0], this.filee[0].name);
      formData.append('nazivtablice', 'ugovori');
      formData.append('ugovor', '1');
      this._ugovoriPopisService.dodajDokument(formData).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno dodan ugovor!");
          this.dohvati();
          this.ugovorForma = this._fb.group({
            naziv: [''],
            file: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sviUgovori = [];
    this._ugovoriPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviUgovori.push({
            'id': res.data[i]['iduploaddokument'],
            'naziv': res.data[i]['ud_naziv'],
            'dokument': res.data[i]['ud_nazivdokumenta_orig'],
            'datum': moment(res.data[i]['ud_vrijemeuplouda']).format('DD.MM.YYYY.'),
            'ud_nazivtablice': res.data[i]['ud_nazivtablice'],
            'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta']
          });
        }
        this.ugovorTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiDokument(ugovor){
    //console.log(ugovor);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati dokument?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ugovoriPopisService.obrisiDokument({'iduploaddokument': ugovor.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Dokument uspješno obrisan!");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja dokumenta.');
    });
  }

  fileChange(event){
    //console.log(event)
    this.filee = event.target.files;
    //console.log(this.filee);
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ugovori-popis/ugovori-popis.component.ts